export default __webpack_public_path__ + "static/media/IMG_2723.fad99eb7.jpg";